import { ActionsUnion, createAction } from 'spw-redux/types';
import { IUserFavoriteProjectsByType, IUserMetrics } from './types';
import { BenchmarkReport } from '../benchmark-reports/types';

export const GET_USER_FAVORITE_PROJECTS = 'home/GET_USER_FAVORITE_PROJECTS';
export const GET_USER_FAVORITE_PROJECTS_SUCCEEDED =
  'home/GET_USER_FAVORITE_PROJECTS_SUCCEEDED';
export const GET_USER_FAVORITE_BENCHMARK_REPORTS =
  'home/GET_USER_FAVORITE_BENCHMARK_REPORTS';
export const GET_USER_FAVORITE_BENCHMARK_REPORTS_SUCCEEDED =
  'home/GET_USER_FAVORITE_BENCHMARK_REPORTS_SUCCEEDED';
export const GET_USER_METRICS = 'home/GET_USER_METRICS';
export const GET_USER_METRICS_SUCCEEDED = 'home/GET_USER_METRICS_SUCCEEDED';
export const CLEAR_HOME_STATE = 'home/CLEAR_HOME_STATE';

export const getUserFavoriteProjects = () =>
  createAction(GET_USER_FAVORITE_PROJECTS);
export const getUserFavoriteProjectsSucceeded = (
  userFavoriteProjects: IUserFavoriteProjectsByType
) => createAction(GET_USER_FAVORITE_PROJECTS_SUCCEEDED, userFavoriteProjects);

export const getUserFavoriteBenchmarkReports = () =>
  createAction(GET_USER_FAVORITE_BENCHMARK_REPORTS);
export const getUserFavoriteBenchmarkReportsSucceeded = (
  favoriteReports: BenchmarkReport[]
) =>
  createAction(GET_USER_FAVORITE_BENCHMARK_REPORTS_SUCCEEDED, favoriteReports);

export const getUserMetrics = () => createAction(GET_USER_METRICS);

export const getUserMetricsSucceeded = (userMetrics: IUserMetrics) =>
  createAction(GET_USER_METRICS_SUCCEEDED, userMetrics);

export const clearHomeState = () => createAction(CLEAR_HOME_STATE);

export const actionNames = {
  GET_USER_FAVORITE_PROJECTS,
  GET_USER_FAVORITE_PROJECTS_SUCCEEDED,
  GET_USER_METRICS,
  GET_USER_METRICS_SUCCEEDED,
  CLEAR_HOME_STATE,
};

export const actions = {
  getUserFavoriteProjects,
  getUserFavoriteProjectsSucceeded,
  getUserFavoriteBenchmarkReports,
  getUserFavoriteBenchmarkReportsSucceeded,
  getUserMetrics,
  getUserMetricsSucceeded,
  clearHomeState,
};

export type Actions = ActionsUnion<typeof actions>;
